export const FILTER_FIELDS_TRANSLATIONS: Record<string, string> = {
  'Click ID': $localize`:@@click.id:Click ID`,
  'Click Hits Count': $localize`:@@click.hits_count:Click Hits Count`,
  'Click Hash': $localize`:@@click.hash:Click Hash`,
  'Device Brand': $localize`:@@common.device_brand:Device Brand`,
  'Device Model': $localize`:@@common.device_model:Device Model`,
  'Click Device OS': $localize`:@@click.device_os:Click Device OS`,
  Platform: $localize`:@@common.platform:Platform`,
  Browser: $localize`:@@common.browser:Browser`,
  'Click Device OS Version': $localize`:@@click.device_os_version:Click Device OS Version`,
  'Click IP': $localize`:@@click.ip:Click IP`,
  'Click Country Code': $localize`:@@click.country_code:Click Country Code`,
  'Click Region Code': $localize`:@@click.region_code:Click Region Code`,
  'Click Affiliate ID': $localize`:@@click.affiliate_id:Click Affiliate ID`,
  'Click Offer ID': $localize`:@@click.offer_id:Click Offer ID`,
  'Click Advertiser ID': $localize`:@@click.advertiser_id:Click Advertiser ID`,
  'Click Brand ID': $localize`:@@click.brand_id:Click Brand ID`,
  'Conversions ID': $localize`:@@conversion.ids:Conversion IDs`,
  'Has Conversion': $localize`:@@conversion.has:Has Conversion`,
  'Goal ID': $localize`:@@goal.id:Goal ID`,
  'Goal Name': $localize`:@@goal.name:Goal Name`,
  'Goal Type': $localize`:@@common.goal_type:Goal Type`,
  'Goal Item Created At': $localize`:@@goal.item_created_at:Goal Item Created At`,
  'Offer Name': $localize`:@@offer.name:Offer Name`,
  'Conversions Payout': $localize`:@@conversion.payout:Conversions Payout`,
  'Payout Model Name': $localize`:@@common.payout_model_name:Payout Model Name`,
  'Payout Model Short Name': $localize`:@@common.payout_model_short_name:Payout Model Short Name`,
  Hash: $localize`:@@common.hash:Hash`,
  'Country Code': $localize`:@@common.country_code:Country Code`,
  'Region Code': $localize`:@@common.region_code:Region Code`,
  'User Agent': $localize`:@@common.user_agent:User Agent`,
  'Created At': $localize`:@@common.created_at:Created At`,
  Identifier: $localize`:@@common.identifier:Identifier`,
  Date: $localize`:@@common.date:Date`,
  'Money Income': $localize`:@@common.money_income:Money Income`,
  cashout: $localize`:@@common.cashout:cashout`,
  'Player ID': $localize`:@@common.player_id:Player ID`,
  'Affiliate Payout': $localize`:@@affiliate.payout:Affiliate Payout`,
  'Offer ID': $localize`:@@offer.id:Offer ID`,
  'Offer Conversions': $localize`:@@offer.conversions:Offer Conversions`,
  'Offer Clicks': $localize`:@@offer.clicks:Offer Clicks`,
  'Offer Unique Clicks': $localize`:@@offer.unique_clicks:Offer Unique Clicks`,
  'Offer Description': $localize`:@@offer.description:Offer Description`,
  'Offer Conversion Type': $localize`:@@offer.conversion_type:Offer Conversion Type`,
  'Offer Conversion Tracking Type': $localize`:@@offer.conversion_tracking_type:Offer Conversion Tracking Type`,
  'Offer Is Private': $localize`:@@offer.is_private:Offer Is Private`,
  'Offer Status': $localize`:@@offer.status:Offer Status`,
  'Sale Status': $localize`:@@common.sale_status:Sale Status`,
  'Hits Count': $localize`:@@common.hits_count:Hits Count`,
  'Advertiser ID': $localize`:@@advertiser.id:Advertiser ID`,
  'Brand ID': $localize`:@@common.brand_id:Brand Id`,
  'Brand Name': $localize`:@@common.brand_name:Brand Name`,
  'Advertiser Status': $localize`:@@advertiser.status:Advertiser Status`,
  'Advertiser Company Name': $localize`:@@advertiser.company_name:Advertiser Company Name`,
  'Advertiser Name': $localize`:@@advertiser.name:Advertiser Name`,
  'Clicks Count': $localize`:@@common.clicks_count:Clicks Count`,
  'Conversions Count': $localize`:@@common.conversions_count:Conversion Count`,
  'Payout Sum': $localize`:@@common.payout_sum:Payout Sum`,
  'Affiliate Questions': $localize`:@@affiliate_questions:Affiliate Questions`,
  'Affiliate Answers': $localize`:@@affiliate_answers:Affiliate Answers`,
  'Private Affiliate First Name': $localize`:@@affiliate.private_first_name:Private Affiliate First Name`,
  'Private Affiliate Last Name': $localize`:@@affiliate.private_last_name:Private Affiliate Last Name`,
  'Private Affiliate Company': $localize`:@@affiliate.private_company:Private Affiliate Company`,
  'Private Affiliate Birthday': $localize`:@@affiliate.private_birthday:Birthday`,
  'Private Affiliate Email': $localize`:@@affiliate.private_affiliate_email:Private Affiliate Email`,
  'Private Affiliate Phone': $localize`:@@affiliate.private_phone:Private Affiliate Phone`,
  'Private Affiliate Telegram': $localize`:@@affiliate.private_telegram:Private Affiliate Telegram`,
  'Private Affiliate Whatsapp': $localize`:@@affiliate.private_whatsapp:Private Affiliate Whatsapp`,
  'Private Affiliate Microsoft Teams (formerly Skype)': $localize`:@@affiliate.private_ms_teams:Private Affiliate Microsoft Teams (formerly Skype)`,
  'Private Advertiser Address': $localize`:@@advertiser.private_address:Private Advertiser Address`,
  'Private Advertiser First Name': $localize`:@@advertiser.private_first_name:Private Advertiser First Name`,
  'Private Advertiser Last Name': $localize`:@@advertiser.private_last_name:Private Advertiser Last Name`,
  'Private Advertiser Phone': $localize`:@@advertiser.private_phone:Private Advertiser Phone`,
  'Private Advertiser Email': $localize`:@@advertiser.private_email:Private Advertiser Email`,
  'Private Advertiser Telegram': $localize`:@@advertiser.private_telegram:Private Advertiser Telegram`,
  'Private Advertiser Microsoft Teams (formerly Skype)': $localize`:@@advertiser.private_ms_teams:Private Advertiser Microsoft Teams (formerly Skype)`,
  'Private Advertiser WhatsApp': $localize`:@@advertiser.private_whatsapp:Private Advertiser WhatsApp`,
  'Affiliate Company Name': $localize`:@@affiliate.name:Affiliate Name`,
  'Affiliate Status': $localize`:@@affiliate.status:Affiliate Status`,
  'Affiliate ID': $localize`:@@affiliate.id:Affiliate ID`,
  'Affiliate Deposit Amount': $localize`:@@affiliate.deposit_amount:Affiliate Deposit Amount`,
  'Affiliate Sales Amount': $localize`:@@affiliate.sales_amount:Affiliate Sales Amount`,
  'Affiliate Withdrawal Amount': $localize`:@@affiliate.withdrawal_amount:Affiliate Withdrawal Amount`,
  'Affiliate Revenue': $localize`:@@affiliate.revenue:Affiliate Revenue`,
  'Affiliate Profit': $localize`:@@affiliate.profit:Affiliate Profit`,
  'Affiliate Name': $localize`:@@affiliate.name:Affiliate Name`,
  'Affiliate Source': $localize`:@@affiliate.source:Affiliate Source`,
  'Affiliate Group ID': $localize`:@@affiliate.group_id:Affiliate Group ID`,
  'Offer  ID': $localize`:@@offer.id:Offer ID`,
  'Offer  Name': $localize`:@@offer.name:Offer Name`,
  'Offer URL ID': $localize`:@@offer.url_id:Offer URL ID`,
  'Offer URL Name': $localize`:@@offer.url_name:Offer URL Name`,
  'Offer Payout Sum': $localize`:@@offer.payout_sum:Offer Payout Sum`,
  'Offer EPC': $localize`:@@offer.epc:Offer EPC`,
  'Offer Country': $localize`:@@offer.country:Offer Country`,
  'Offer Language': $localize`:@@offer.language:Offer Language`,
  'Offer Privacy': $localize`:@@offer.privacy:Offer Privacy`,
  'Offer Is White': $localize`:@@offer.is_white:Offer Is White`,
  'Device OS': $localize`:@@common.device_os:Device OS`,
  'Device OS Version': $localize`:@@common.device_os_version:Device OS Version`,
  'Network Deposit Amount': $localize`:@@common.network_deposit_amount:Network Deposit Amount`,
  'Network Sales Amount': $localize`:@@common.network_sales_amount:Network Sales Amount`,
  'Network Withdrawal Amount': $localize`:@@common.network_withdrawal_amount:Network Withdrawal Amount`,
  'Network Payout': $localize`:@@common.network_payout:Network Payout`,
  'Network Revenue': $localize`:@@common.network_revenue:Network Revenue`,
  'Network Profit': $localize`:@@common.network_profit:Network Profit`,
  'Click Sale Status': $localize`:@@common.click_sale_status:Click Sale Status`,
  'Is Test': $localize`:@@common.is_test:Is Test`,
  'Is Unique': $localize`:@@common.is_unique:Is Unique`,
  'Group Hash': $localize`:@@common.group_hash:Group Hash`,
  'Goal Type ID': $localize`:@@common.goal_type_id:Goal Type ID`,
  'Conversions For Test': $localize`:@@conversion.conversions_for_test:Conversions For Test`,
  'Conversions Sale Amount': $localize`:@@conversion.conversions_sale_amount:Conversions Sale Amount`,
  'Conversions Deposit Amount': $localize`:@@conversion.conversions_deposit_amount:Conversions Deposit Amount`,
  'Conversions Revenue': $localize`:@@conversion.conversions_revenue:Conversions Revenue`,
  'Conversion Profiles': $localize`:@@conversion.conversion_profiles:Conversion Profiles`,
  'Private Conversion Profiles': $localize`:@@conversion.private_conversion_profiles:Private Conversion Profiles`,
  'Revenue Model Name': $localize`:@@common.revenue_model_name:Revenue Model Name`,
  'Revenue Model Short Name': $localize`:@@common.revenue_model_short_name:Revenue Model Short Name`,
  'Private First Name': $localize`:@@common.private_first_name:Private First Name`,
  'Earning ID': $localize`:@@earning.id:Earning ID`,
  'Earning Name': $localize`:@@earning.name:Earning Name`,
  'Earning Status': $localize`:@@earning.status:Earning Status`,
  'Earning From': $localize`:@@earning.from:Earning From`,
  'Earning To': $localize`:@@earning.to:Earning To`,
  'Earning Total': $localize`:@@earning.total:Earning Total`,
  'Private Default Payment Method': $localize`:@@finance.private_default_payment_method:Private Default Payment Method`,
  'Private Default Payment Method Account': $localize`:@@finance.private_default_payment_method_account:Private Default Payment Method Account`,
  'Private Default Payment Method Currency': $localize`:@@finance.private_default_payment_method_currency:Private Default Payment Method Currency`,
  'Private Default Payment Method Details': $localize`:@@finance.private_default_payment_method_details:Private Default Payment Method Details`,
  'Invoice ID': $localize`:@@invoice.id:Invoice ID`,
  'Invoice Name': $localize`:@@invoice.name:Invoice Name`,
  'Invoice Status': $localize`:@@invoice.status:Invoice Status`,
  'Invoice Comment': $localize`:@@invoice.comment:Invoice Comment`,
  'Invoice From': $localize`:@@invoice.from:Invoice From`,
  'Invoice To': $localize`:@@invoice.to:Invoice To`,
  'Invoice Total': $localize`:@@invoice.total:Invoice Total`,
  'Invoice Total Paid': $localize`:@@invoice.total_paid:Invoice Total Paid`,
  'Private Payment Method': $localize`:@@finance.private_payment_method:Private Default Payment Method`,
  'Private Payment Method Account': $localize`:@@finance.private_payment_method_account:Private Default Payment Method Account`,
  'Private Payment Method Currency': $localize`:@@finance.private_payment_method_currency:Private Default Payment Method Currency`,
  'Private Payment Method Details': $localize`:@@finance.private_payment_method_details:Private Default Payment Method Details`,
  'Payment ID': $localize`:@@finance.payment_id:Payment ID`,
  'Payment Name': $localize`:@@finance.payment_name:Payment Name`,
  'Payment Status': $localize`:@@finance.payment_status:Payment Status`,
  'Payment From': $localize`:@@finance.payment_from:Payment From`,
  'Payment To': $localize`:@@finance.payment_to:Payment To`,
  'Payment Total': $localize`:@@finance.payment_total:Payment Total`,
  'Payment Total Paid': $localize`:@@finance.payment_total_paid:Payment Total Paid`,
  'Payment Total Commissions': $localize`:@@finance.payment_total_commissions:Payment Total Commissions`,
  'Conversions Currency': $localize`:@@conversion.currency:Conversions Currency`,
  'Earning Currency': $localize`:@@earning.currency:Earning Currency`,
  'Invoice Currency': $localize`:@@invoice.currency:Invoice Currency`,
  'Offer Currency': $localize`:@@offer.currency:Offer Currency`,
  'Payment Currency': $localize`:@@payment.currency:Payment Currency`,
  Activity: $localize`:@@common.activity:Activity`,
  Currency: $localize`:@@common.currency:Currency`,
};
